module.exports = __webpack_public_path__ + "assets-cabinet/img/send.3f49378e.svg";